import { RessourcesModel } from '../models/ressources.model';

export class RessourcesModelService {

    /**
     * Calcul du total des ressources si définies
     * On additionne x et y en faisant : +x + +y
     * Si on avait fait x + y ça aurait fait une concaténation !
     */
    static calculerTotal(ressources : RessourcesModel) : number {
        let result = 0;

        if (ressources.salaireDefini) {
            result = +result + +ressources.montantSalaire;
        }
        if (ressources.chomagePreretraitreDefini) {
            result = +result + +ressources.montantChomagePreretraitre;
        }
        if (ressources.pensionAlimentaireDefini) {
            result = +result + +ressources.montantPensionAlimentaire;
        }
        if (ressources.retraitrePensionDefini) {
            result = +result + +ressources.montantRetraitrePension;
        }
        if (ressources.revenuIndependentAnneeMoins2Defini) {
            result = +result + +ressources.montantRevenuIndependentAnneeMoins2;
        }

        return result;
    }

}
